import React, { Component, Fragment } from 'react';
import styles from './ConfigPanel.module.css';
import ReactSelect from 'react-select';
import Button from '../Button';
import Divider from '../Divider';

const itemCodes = Array(1000)
  .fill()
  .map((e, i) => ({ label: i + 1, value: i + 1 }));

export default class ConfigPanel extends Component {
  state = {
    addNode: false,
    addRule: {},
    nodeNames: {
      Cushion: { label: 'Cushion', value: 'Cushion' },
      Frame: { label: 'Frame', value: 'Frame' },
      Legs: { label: 'Legs', value: 'Legs' },
      Glides: { label: 'Glides', value: 'Glides' },
      Nailheads: { label: 'Nailheads', value: 'Nailheads' },
      Pillow: { label: 'Pillow', value: 'Pillow' },
      'Cushion Welt': { label: 'Cushion Welt', value: 'Cushion Welt' },
      'Frame Welt': { label: 'Frame Welt', value: 'Frame Welt' },
      'Pillow Welt': { label: 'Pillow Welt', value: 'Pillow Welt' },
      FrameAccent: { label: 'Frame Accent', value: 'FrameAccent' },
      CasterLegs: { label: 'Caster Legs', value: 'CasterLegs' },
      CasterGlides: { label: 'Caster Glides', value: 'CasterGlides' },
    },
  };

  renderSingleConfig(item) {
    return (
      <div className={styles.singleConfig}>
        <div className={styles.attrName}> {item.name}</div>
        <div>
          <div> Rules </div>
          {item.values &&
            item.values.map((value, k) =>
              this.renderAttributeValue(item.name, value, k)
            )}
          <div
            className={styles.addNode}
            onClick={e => this.setRules(item.name)}
          >
            + Add rules
          </div>
        </div>
      </div>
    );
  }

  addNode = () => {
    const { addNode } = this.state;
    if (addNode) return;
    this.setState({ addNode: true });
  };

  setRules = attribute => {
    const { addRule } = this.state;
    addRule[attribute] = {};
    this.setState({ addRule });
  };

  setAttribute = (data, type, attr, key) => {
    if (typeof key !== 'undefined') {
      const { setProduct, product } = this.props;
      const attribute = product.rules.find(item => item.name === attr);
      if (!attribute) return;
      const index = product.rules.indexOf(attribute);
      attribute['values'][key][type] =
        type === 'value' || type === 'type' || type === 'condition'
          ? data
          : data && data.map(item => item.value);
      product.rules[index] = attribute;
      setProduct(product);
    } else {
      const { addRule } = this.state;
      if (!addRule[attr]) return;
      addRule[attr][type] =
        type === 'value' || type === 'type' || type === 'condition'
          ? data
          : data && data.map(item => item.value);
      this.setState({ addRule });
    }
  };

  updateAttribute = (attribute, type, data) => {
    if (!type) {
      const { addRule } = this.state;
      const attributeValue = addRule[attribute];
      if (!attributeValue) return;
      const { setProduct, product } = this.props;
      const attr = product.rules.find(item => item.name === attribute);
      if (!attr) return;
      const index = product.rules.indexOf(attr);
      attr.values.push(attributeValue);
      product.rules[index] = attr;
      setProduct(product);
      delete addRule[attribute];
      this.setState({ addRule });
      return;
    }
    const { setProduct, product } = this.props;
    const attr = product.rules.find(item => item.name === attribute);
    if (!attr) return;
    const index = product.rules.indexOf(attr);
    attr[type] = data && data.value;
    product.rules[index] = attr;
    setProduct(product);
  };

  addAttribute = () => {
    const { product, setProduct } = this.props;
    const node = this.refs['addNode'].value;
    product.rules.push({ name: node, values: [] });
    this.refs['addNode'].value = '';
    this.setState({ addNode: false });
    setProduct(product);
  };

  deleteRule = (attr, key) => {
    if (typeof key === 'undefined') return;
    const { setProduct, product } = this.props;
    const rules = product.rules;
    const attribute = rules.find(item => item.name === attr);
    attribute.values.splice(key, 1);
    setProduct(product);
  };

  renderOptions = type => {
    if (type === 'camera') {
      return [];
    } else if (type === 'scene') {
      const { scenes } = this.props;
      if (scenes) {
        return Object.keys(scenes).map(id => ({
          label: scenes[id].friendlyName,
          value: id,
        }));
      } else {
        return [];
      }
    } else {
      const { product, tags } = this.props;
      const materialOptions =
        product.materials.length && product.materials[0].label
          ? product.materials
          : product.materials.map(item => ({
              label: item,
              value: item,
            }));
      const options =
        tags && tags.length ? tags.map(item => item[0]) : materialOptions;
      return options;
    }
  };

  renderAttributeValue = (attribute, value, key) => {
    const { nodeNames, addRule } = this.state;
    if (!value) value = addRule[attribute];
    if (value['nodes'] && value['nodes'].length) {
      for (let i in value['nodes']) {
        if (!nodeNames[value['nodes'][i]]) {
          nodeNames[value['nodes'][i]] = {
            label: value['nodes'][i],
            value: value['nodes'][i],
          };
        }
      }
    }
    const isMulti = value.type !== 'scene' && value.type !== 'camera';
    return (
      <Fragment>
        <div className={styles.addRuleRow}>
          <div className={styles.addNodeLabel}> Type *</div>
          <ReactSelect
            className={styles.selectContainer}
            options={[
              { label: 'Material', value: 'material' },
              { label: 'Background', value: 'scene' },
              { label: 'Camera', value: 'camera' },
              { label: 'Contiional Rule', value: 'conditional' },
            ]}
            onChange={data =>
              this.setAttribute(data.value, 'type', attribute, key)
            }
            value={value['type']}
          />
        </div>
        <img
          className={styles.deleteRule}
          src="/img/close.png"
          onClick={e => this.deleteRule(attribute, key)}
        />
        {isMulti && (
          <div className={styles.addRuleRow}>
            <div className={styles.addNodeLabel}> Nodes *</div>
            <ReactSelect.Creatable
              className={styles.selectContainer}
              multi={true}
              options={Object.values(nodeNames)}
              value={value['nodes']}
              onChange={data =>
                this.setAttribute(data, 'nodes', attribute, key)
              }
            />
          </div>
        )}
        <div className={styles.addRuleRow}>
          <div className={styles.addNodeLabel}> Value *</div>
          <ReactSelect.Creatable
            className={styles.selectContainer}
            multi={isMulti ? true : false}
            options={this.renderOptions(value.type)}
            value={value['value']}
            onChange={data => this.setAttribute(data, 'value', attribute, key)}
          />
        </div>
        {value['type'] === 'conditional' && (
          <div className={styles.addRuleRow}>
            <div className={styles.addNodeLabel}> Conditaions</div>
            <div style={{ display: 'flex' }}>
              <ReactSelect.Creatable
                className={styles.conditionSelect}
                options={[
                  { label: 'Item Code', value: 'itemcode' },
                  { label: 'Material Code', value: 'materialcode' },
                ]}
                value={value['condition']}
                onChange={data =>
                  this.setAttribute(data, 'condition', attribute, key)
                }
              />
              <div className={styles.conditionOp}> In </div>
              <ReactSelect.Creatable
                className={styles.conditionSelect}
                multi={true}
                options={itemCodes}
                value={value['conditionValue']}
                onChange={data =>
                  this.setAttribute(data, 'conditionValue', attribute, key)
                }
              />
            </div>
          </div>
        )}
        <Divider />
      </Fragment>
    );
  };

  renderConfig() {
    const { product, updateProduct, onClose, hiddenBtn } = this.props;
    const { addNode, addRule } = this.state;
    return (
      <div className={styles.container}>
        {product.name && (
          <div className={styles.headerContainer}>
            <div className={styles.header}> {product.name} </div>
            <div className={styles.closeIcon} onClick={onClose} />
          </div>
        )}
        <div className={styles.content}>
          <div className={styles.leftContent}>
            <div className={styles.title}> Attributes </div>
            <div className={styles.subtitle}> * Required </div>
          </div>
          <div className={styles.rightContent}>
            {product.rules.map(v => this.renderSingleConfig(v))}
            <div className={styles.addNode} onClick={this.addNode}>
              + Add attribute
            </div>
            {addNode && (
              <div className={styles.addNodeContainer}>
                <div className={styles.addNodeLabel}> Attribute Name *</div>
                <input className={styles.addNodeInput} ref="addNode" />
                <Button
                  text="Add"
                  height="32px"
                  onClick={e => this.addAttribute(null)}
                />
              </div>
            )}
            {Object.keys(addRule).map(attribute => (
              <div className={styles.addRuleContainer}>
                <div className={styles.attrName}>{attribute}</div>
                {this.renderAttributeValue(attribute)}
                <div className={styles.addRuleButton}>
                  <Button
                    text="Add"
                    height="32px"
                    onClick={e => this.updateAttribute(attribute)}
                  />
                </div>
              </div>
            ))}
            {!hiddenBtn && (
              <div className={styles.buttonContainer}>
                <Button text="Update" onClick={e => updateProduct(product)} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return <div className={styles.productContainer}>{this.renderConfig()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/ConfigPanel/index.js